export default __webpack_public_path__ + "static/media/moon-S.aaec7532.jpg";